import React from 'react';
import styled from '@emotion/styled';
import { Config, StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

const LaptopImageContainer = styled.div({
  alignSelf: 'center',
  backgroundImage: `url(${Config.get('image_cdn_base_url')}/metadata/products/third-party/laptop_frame.svg)`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  position: 'relative',
  textAlign: 'center',
  width: '100%',
  height: '100%',
});

const LaptopImageContent = styled.img({
  marginTop: pxToRem(12),
  width: '76.6%',

  [mqBreakpoints.tablet]: {
    marginTop: pxToRem(27),
  },

  [mqBreakpoints.desktop]: {
    marginTop: pxToRem(38),
  },
});

type Props = {
  image: string;
};

export const BenefitsTpLaptop: React.FC<Props> = ({ image }) => {
  return (
    <LaptopImageContainer>
      <LaptopImageContent src={`${Config.get('image_cdn_base_url')}/${image}`} alt='Product screenshot' data-testid='mp-product-benefits-image' />
    </LaptopImageContainer>
  );
};
